import React, { useState } from 'react';
import { Dropdown } from "react-bootstrap";
import { BsList } from "react-icons/bs";
import { useParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';

const ComboBoxWithIcon = () => {
  const navigate = useNavigate();
  const { keyword: urlKeyword } = useParams();
  
  const [keyword, setKeyword] = useState(urlKeyword || '');

  const handleSelect = (e) => {
    console.log(e);
    if (e) {
      navigate(`/category/${e}`);
      setKeyword('');
    } else {
      navigate('/');
    }
  };
  
  return (
    <Dropdown className="btn-combo" onSelect={handleSelect}>
      <Dropdown.Toggle variant="light" className="btn-combo-toggle">
        <span className="text-left text-white">Categorías</span>
        <BsList size={22} className="text-white" />
      </Dropdown.Toggle>

      <Dropdown.Menu className="btn-combo-menu w-100">
        <Dropdown.Item eventKey="4x4">4x4 / 4WD</Dropdown.Item>
        <Dropdown.Item eventKey="Camper">Camper</Dropdown.Item>
        <Dropdown.Item eventKey="Marítima">Marítima</Dropdown.Item>
        <Dropdown.Item eventKey="Portable">Portable</Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  );
}

export default ComboBoxWithIcon;